import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './views/app'
import * as Sentry from '@sentry/browser'

const el = document.getElementById('tickets-app')

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: el.dataset.sentryDsn,
    environment: process.env.NODE_ENV
  })
}

const root = createRoot(el)
root.render(<App cartPath={el.dataset.cartPath} />)
